module.exports = __webpack_public_path__ + "img/step5-no.284e39f9.png";